import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=24adea24&scoped=true"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./PageBreadcrumb.vue?vue&type=style&index=0&id=24adea24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24adea24",
  null
  
)

export default component.exports